"use strict";

exports.__esModule = true;
exports.LAYOUTS_MOBILE = exports.REPEAT_VALUES = exports.BACKGROUND_TYPES = exports.LINE_ALIGNMENTS = void 0;

/** @type {{[key: string]: Alignment}} */
var LINE_ALIGNMENTS = {
  START: "flex-start",
  CENTER: "center",
  END: "flex-end"
};
exports.LINE_ALIGNMENTS = LINE_ALIGNMENTS;
var BACKGROUND_TYPES = {
  TRANSPARENT: "transparent",
  COLOR: "color",
  IMAGE: "image"
};
exports.BACKGROUND_TYPES = BACKGROUND_TYPES;
var REPEAT_VALUES = [{
  name: "Ne pas répéter",
  value: "no-repeat"
}, {
  name: "Répéter",
  value: "repeat"
}, {
  name: "Répéter horizontalement",
  value: "repeat-x"
}, {
  name: "Répéter verticalement",
  value: "repeat-y"
}];
exports.REPEAT_VALUES = REPEAT_VALUES;
var LAYOUTS_MOBILE = {
  COLUMN: "column",
  COLUMN_REVERSE: "column-reverse",
  ROW: "row"
};
exports.LAYOUTS_MOBILE = LAYOUTS_MOBILE;